export const environment = {
    production: false,
    // API base URL - all AI calls go through backend
    // apiBaseUrl: 'http://localhost:5000',
    apiBaseUrl: 'https://hcus-wa-api-app-uat-bxb4bahhgad6bvek.eastus-01.azurewebsites.net',
    dbName: 'v2', // Database version for dev

    msalConfig: {
        auth: {
            clientId: '5026eda0-f698-44f0-9f6c-e1ec27db40a0',
            authority: 'https://login.microsoftonline.com/428ca335-9e45-413a-96dd-f730aabb7a97'
        }
    },
    apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft.com/v1.0/me'
    },
    appInsights: {
        instrumentationKey: '8ed4017e-b8b5-4adb-b119-7da3bede1c9f',
        apiUrl: 'https://hcus-wa-api-app-uat-bxb4bahhgad6bvek.eastus-01.azurewebsites.net',
        dbName: 'v2',
        appName: '/subscriptions/c10e2822-7464-4050-b33f-1d2e8a5341e4/resourcegroups/hcus-analyticspoc-rg/providers/microsoft.insights/components/hcus-wa-ui-app-dev',
        iKey: '8ed4017e-b8b5-4adb-b119-7da3bede1c9f',
        resourceId: '/subscriptions/c10e2822-7464-4050-b33f-1d2e8a5341e4/resourcegroups/hcus-analyticspoc-rg/providers/microsoft.insights/components/hcus-wa-ui-app-dev'
    }
};
